import { contentPreviewSource, convertImage } from '../../../../services/contents'

// Maps API entities to the shapes the Ad Library presentational components expect.
// Replaces the old utils/mockData.js: the feature now runs entirely on API data
// (contents == ads, content-tags == folders, plus real clients/brands).

// content (GET /companies|users/{id}/contents -> data[]) -> AdCard shape.
// See docs/contents-flow.md for the full content structure.
// file_thumb is a full URL (…-thumb.jpg) or the literal "pending" while the
// backend renders the preview. A dynamic ad (type 'url' / 'url_reload') has no
// media of its own: `file` is the ad URL and preview_file / preview_type describe
// the still or clip uploaded to stand in for it.
export const mapContentToAd = (content) => ({
  id: content.id,
  name: content.name,
  type: content.type, // 'image' | 'video' | 'url' | 'url_reload'
  width: content.width,
  height: content.height,
  thumbnail: content.file_thumb && content.file_thumb !== 'pending' ? convertImage(content.file_thumb) : '',
  pending: content.file_thumb === 'pending',
  file: content.file,
  // Null while a video preview transcodes, so the consumer shows the fallback icon
  // instead of the 'pending' sentinel as a src.
  previewFile: contentPreviewSource(content),
  previewType: content.preview_type,
  date: content.created_at || '',
  versionName: content.version_name,
  category: content.category || null,
  countDisplays: content.count_displays != null ? content.count_displays : 0,
  // The content has no `status` field; default it for the (cosmetic) status filter.
  status: content.status || 'available',
})

// tag (GET /companies|users/{id}/contents-tags) -> FolderCard shape.
// See docs/contents-flow.md. The identifier is `id` (FolderSelect uses folder.id);
// it is the `tag` query param when listing contents. `key` mirrors `id` so the
// component can keep using folder.key for selection. `children` are subfolders
// (mapped recursively); the listing currently renders the top level only.
export const mapTagToFolder = (tag) => ({
  id: tag.id,
  key: tag.id,
  name: tag.name,
  parentId: tag.parent_id,
  rootId: tag.root_id,
  brandId: tag.brand_id,
  clientId: tag.client_id,
  userId: tag.user_id,
  isAutoGenerated: tag.is_auto_generated,
  itemsCount: tag.contents_count != null ? tag.contents_count : 0,
  createdAt: tag.created_at || '',
  children: Array.isArray(tag.children) ? tag.children.map(mapTagToFolder) : [],
})

// "2026-04-21 11:26:43" -> "2026-04-21" (date portion only); "-" when empty.
export const formatDate = (value) => (value ? String(value).split(' ')[0] : '-')
